/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDRadiusDownLeftIcon32Regular = forwardRef('ArrowDRadiusDownLeftIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M27 6c0 6.075-4.925 11-11 11H5.415l7.292-7.293a1 1 0 1 0-1.414-1.414l-7.338 7.338a3.35 3.35 0 0 0 0 4.738l7.338 7.338a1 1 0 0 0 1.414-1.414L5.414 19H16c7.18 0 13-5.82 13-13V5a1 1 0 1 0-2 0v1Z" })));
});
